/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ArtistRemixContestEndingSoonNotificationActionData } from './ArtistRemixContestEndingSoonNotificationActionData';
import {
    ArtistRemixContestEndingSoonNotificationActionDataFromJSON,
    ArtistRemixContestEndingSoonNotificationActionDataFromJSONTyped,
    ArtistRemixContestEndingSoonNotificationActionDataToJSON,
} from './ArtistRemixContestEndingSoonNotificationActionData';

/**
 * 
 * @export
 * @interface ArtistRemixContestEndingSoonNotificationAction
 */
export interface ArtistRemixContestEndingSoonNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestEndingSoonNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestEndingSoonNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof ArtistRemixContestEndingSoonNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {ArtistRemixContestEndingSoonNotificationActionData}
     * @memberof ArtistRemixContestEndingSoonNotificationAction
     */
    data: ArtistRemixContestEndingSoonNotificationActionData;
}

/**
 * Check if a given object implements the ArtistRemixContestEndingSoonNotificationAction interface.
 */
export function instanceOfArtistRemixContestEndingSoonNotificationAction(value: object): value is ArtistRemixContestEndingSoonNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function ArtistRemixContestEndingSoonNotificationActionFromJSON(json: any): ArtistRemixContestEndingSoonNotificationAction {
    return ArtistRemixContestEndingSoonNotificationActionFromJSONTyped(json, false);
}

export function ArtistRemixContestEndingSoonNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistRemixContestEndingSoonNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': ArtistRemixContestEndingSoonNotificationActionDataFromJSON(json['data']),
    };
}

export function ArtistRemixContestEndingSoonNotificationActionToJSON(value?: ArtistRemixContestEndingSoonNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': ArtistRemixContestEndingSoonNotificationActionDataToJSON(value.data),
    };
}

